import { render, staticRenderFns } from "./VipUser.vue?vue&type=template&id=286426d1&scoped=true&"
import script from "./VipUser.vue?vue&type=script&lang=js&"
export * from "./VipUser.vue?vue&type=script&lang=js&"
import style0 from "./VipUser.vue?vue&type=style&index=0&id=286426d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286426d1",
  null
  
)

export default component.exports